import VendasCupomService from "@/services/VendasCupomService";

export const vendasCupom = {
  namespaced: true,
  state: {
    vendasCupom: {},
  },
  actions: {
    getVendasCupom({ commit }, payload) {
      return VendasCupomService.GetVendasCupom(payload).then(
        (vendasCupom) => {
          return Promise.resolve(vendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVendasCupom({ commit }, payload) {
      return VendasCupomService.PostVendasCupom(payload).then(
        (vendasCupom) => {
          return Promise.resolve(vendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVendasCupom({ commit }, payload) {
      return VendasCupomService.PutVendasCupom(payload).then(
        (vendasCupom) => {
          return Promise.resolve(vendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVendasCupom({ commit }, payload) {
      return VendasCupomService.DeleteVendasCupom(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVendasCupomOData({ commit }, payload) {
      return VendasCupomService.GetVendasCupomOData(payload).then(
        (vendasCupom) => {
          return Promise.resolve(vendasCupom);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    transformarVenda({ commit }, payload) {
      return VendasCupomService.TransformarVenda(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default vendasCupom;
